/**
 * @generated SignedSource<<c73b84528b32969738991b784b8fc5a4>>
 * @relayHash 788b2558ba947f1feca9c76145ac9019
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 725fbd46a2bbd5c4e2910fd04de40d9b84fdd5fb72a23bf6fcbffc5862450003

import type { ConcreteRequest } from 'relay-runtime';
export type ContentVersionHistoryFilter = {
  contentType: string;
};
export type useAttachmentVersionsQuery$variables = {
  attachmentId: string;
  filter: ContentVersionHistoryFilter;
};
export type useAttachmentVersionsQuery$data = {
  readonly contentVersionHistory: {
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly displayName: string | null;
        readonly id: string | null;
      } | null;
      readonly message: string | null;
      readonly number: number;
      readonly updatedTime: string;
    }>;
  } | null;
};
export type useAttachmentVersionsQuery = {
  response: useAttachmentVersionsQuery$data;
  variables: useAttachmentVersionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "attachmentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 100
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "attachmentId"
      }
    ],
    "concreteType": "ContentVersionHistoryConnection",
    "kind": "LinkedField",
    "name": "contentVersionHistory",
    "plural": false,
    "selections": [
      {
        "concreteType": "ContentVersion",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "number"
          },
          {
            "kind": "ScalarField",
            "name": "updatedTime"
          },
          {
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAttachmentVersionsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAttachmentVersionsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "788b2558ba947f1feca9c76145ac9019",
    "id": "725fbd46a2bbd5c4e2910fd04de40d9b84fdd5fb72a23bf6fcbffc5862450003",
    "metadata": {},
    "name": "useAttachmentVersionsQuery",
    "operationKind": "query",
    "text": "query useAttachmentVersionsQuery($attachmentId:ID!,$filter:ContentVersionHistoryFilter!){contentVersionHistory(id:$attachmentId,first:100,filter:$filter){nodes{number,updatedTime,author{id,displayName},message}}}"
  }
};
})();

(node as any).hash = "341106a5916dead04c88b1727c2fd806";

export default node;
